
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';
import { useTranslation } from 'react-i18next';

export default function GaugeUi ({value}) {

    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    return(<>
        
        <div className='flex flex-col justify-center items-center bg-thirdly sm:p-5 p-3 rounded-lg max-h-60 '>
            <label className='text-white mb-3 font-semibold text-md tracking-wider text-center'>
            {t("charts.total_app_downloads")}
            </label>
            <Gauge 
                  sx={(theme) => ({
                [`& .${gaugeClasses.valueText}`]: {
                fontSize: 20,
                },
                [`& .${gaugeClasses.valueArc}`]: {
                fill: '#52b202',
                },
                [`& .${gaugeClasses.referenceArc}`]: {
                fill: theme.palette.text.disabled,
                },
            })}
            // value={26} startAngle={0} endAngle={360} innerRadius="94%" outerRadius="100%" />
            value={value.total_app_downloads == null ? 0 : value.total_app_downloads} startAngle={0} endAngle={360} innerRadius="94%" outerRadius="100%" />
        </div>

        <div className='flex flex-col justify-center items-center bg-thirdly sm:p-5 p-3 rounded-lg max-h-60'>
            <label className='text-white mb-3 font-semibold text-md tracking-wider text-center'>
            {t("charts.total_website_visits")}
            </label>
            <Gauge
                  sx={(theme) => ({
                [`& .${gaugeClasses.valueText}`]: {
                fontSize: 20,
                },
                [`& .${gaugeClasses.valueArc}`]: {
                fill: '#b20902',
                },
                [`& .${gaugeClasses.referenceArc}`]: {
                fill: theme.palette.text.disabled,
                },
            })}
            value={value.total_website_visits} startAngle={0} endAngle={360} innerRadius="94%" outerRadius="100%" />
        </div>

        <div className='flex flex-col justify-center items-center bg-thirdly sm:p-5 p-3 rounded-lg max-h-60'>
            <label className='text-white mb-3 font-semibold text-md tracking-wider text-center'>
            {t("charts.active_users_now")}
            </label>
            <Gauge
                  sx={(theme) => ({
        [`& .${gaugeClasses.valueText}`]: {
          fontSize: 20,
        },
        [`& .${gaugeClasses.valueArc}`]: {
          fill: '#fa8c16',
        },
        [`& .${gaugeClasses.referenceArc}`]: {
          fill: theme.palette.text.disabled,
        },
      })}
            value={value.active_users_now} startAngle={0} endAngle={360} innerRadius="94%" outerRadius="100%" />
        </div>

        <div className='flex flex-col justify-center items-center bg-thirdly sm:p-5 p-3 rounded-lg max-h-60'>
            <label className='text-white mb-3 font-semibold text-md tracking-wider text-center'>
            {t("charts.app_usage_hours")}
            </label>
            <Gauge 
                  sx={(theme) => ({
        [`& .${gaugeClasses.valueText}`]: {
          fontSize: 20,
        },
        [`& .${gaugeClasses.valueArc}`]: {
          fill: '#12b2e3',
        },
        [`& .${gaugeClasses.referenceArc}`]: {
          fill: theme.palette.text.disabled,
        },
      })}
            // value={4} startAngle={0} endAngle={360} innerRadius="94%" outerRadius="100%" />
          value={value.app_usage_hours} startAngle={0} endAngle={360} innerRadius="94%" outerRadius="100%" />
        </div>

    </>);
};